import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, XCircle } from 'lucide-react';
export function AudienceSection() {
  return <section className="py-20 bg-white" data-id="element-27">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-28">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-29">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-green-50 p-8 rounded-3xl border border-green-100" data-id="element-30">
            <h3 className="text-2xl font-bold text-green-900 mb-8 flex items-center gap-3" data-id="element-31">
              <CheckCircle className="w-8 h-8 text-green-600" data-id="element-32" />
              Este ebook es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-33">
              {['Cobras quincenal o mensual', 'Sientes que el dinero nunca alcanza', 'Te esfuerzas pero no ves resultados', 'Estás cansada de vivir con ansiedad financiera'].map((item, i) => <li key={i} className="flex items-center gap-3 text-green-800 font-medium" data-id="element-34">
                  <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-35" />
                  {item}
                </li>)}
            </ul>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-red-50 p-8 rounded-3xl border border-red-100" data-id="element-36">
            <h3 className="text-2xl font-bold text-red-900 mb-8 flex items-center gap-3" data-id="element-37">
              <XCircle className="w-8 h-8 text-red-600" data-id="element-38" />
              No es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-39">
              {['Buscas hacerte rica rápido', 'No quieres cambiar nada', 'Crees que el problema es “el cafecito”'].map((item, i) => <li key={i} className="flex items-center gap-3 text-red-800 font-medium" data-id="element-40">
                  <XCircle className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-41" />
                  {item}
                </li>)}
            </ul>
          </motion.div>
        </div>

        <div className="mt-12 text-center max-w-2xl mx-auto" data-id="element-42">
          <p className="text-lg text-amber-900 italic" data-id="element-43">
            "La culpa no está en un gusto pequeño. Está en no saber cuánto
            puedes gastar sin sabotearte. Quincena Milagrosa no te quita
            placeres. Te devuelve el control."
          </p>
        </div>
      </div>
    </section>;
}